import { ThirdPartyRefundProvider } from "@redotech/redo-return-core-common/third-party-refunds/provider";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const setThirdPartyRefundProvider = {
  name: "setThirdPartyRefundProvider" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    thirdPartyRefundProvider: createEnum(ThirdPartyRefundProvider).nullish(),
  }),
  output: z.object({
    thirdPartyRefundProvider: createEnum(ThirdPartyRefundProvider).nullish(),
  }),
};
